import "./Header.css";
import {
  Container,
  Nav,
  Navbar,
  NavDropdown,
} from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useSelector } from "react-redux";
import { useLogout } from "../../../utilities";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminNavMenu from "./AdminNavMenu";
import UserCartMenuItem from "./UserCartMenuItem";
import UserNavMenu from "./UserNavMenu";
import SearchBar from "./SearchBar";
import ModalMessage from "../ModalMessage";

export default function Header() {
  // top navigation bar of the web application, including the shop name, search bar, and specific navigation menu (different for admin/regular user)
  const navigate = useNavigate();
  const logout = useLogout();
  const { isAdmin, isAuthenticated, firstName, unreadMessages } =
    useSelector((state) => state.user);
  const { storeName, logo } = useSelector((state) => state.appConfig);
  const { quantity } = useSelector((state) => state.cart);
  const [navExpanded, setNavExpanded] = useState(false);
  const [showLogoutMsg, setShowLogoutMsg] = useState(false);

  const toggleNavExpansion = () => {
    setNavExpanded(!navExpanded);
  };

  const chatMsgIndicator = (
    <div>
      {isAdmin && unreadMessages && Object.keys(unreadMessages).length > 0 && (
        <span className="position-absolute top-0 start-0 translate-middle p-2 bg-danger border border-light rounded-circle"></span>
      )}
    </div>
  );

      const handleLogout = () => {
        if(isAdmin){
          setShowLogoutMsg(true);
        } else {
          logout();
        }
      }

  return (
    <>
      <Navbar
        expanded={navExpanded}
        expand="lg"
        variant="dark"
        className="top-navbar"
      >
        <Container>
        <div style={{display: "flex", alignItems: "center"}} onClick={() => navigate("/")} className="pointer">

        {logo?.url && <img src={logo?.url} alt="logo" style={{width: "35px", height: "35px"}}></img>}
          <Navbar.Brand  className="header-logo logo">{storeName}</Navbar.Brand>
        </div>
          <div style={{ position: "relative", marginRight: "2%" }}>
            <Navbar.Toggle
              aria-controls="responsive-navbar-nav"
              onClick={toggleNavExpansion}
            />
            {/*visible only when < than lg breakpoint */}
            <span className="d-inline d-lg-none">{chatMsgIndicator}</span>{" "}
          </div>
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              {/* SEARCH BAR */}
              <SearchBar />
            </Nav>
            <Nav>
              {/* ADMIN MENU */}
              {/* ..large screen */}
              {isAdmin && isAuthenticated && (
                <NavDropdown
                  className="navbar-admin-button navbar-collapsed-menu-button"
                  title={
                    <span
                      style={{ position: "relative", paddingLeft: "8px" }}
                      className="navbar-main-button"
                    >
                      Admin
                      <span className="d-none d-lg-inline ">
                        {chatMsgIndicator}
                      </span>{" "}
                      {/*visible only when >= lg breakpoint */}
                    </span>
                  }
                  id="collasible-nav-dropdown"
                >
                  <AdminNavMenu logout={handleLogout}                     toggleNavExpansion={toggleNavExpansion}
/>
                </NavDropdown>
              )}
              {/* ..small screen */}
              {isAdmin && isAuthenticated && (
                <div className="navbar-admin-menu-small-screen">
                  <AdminNavMenu
                    logout={handleLogout}
                    toggleNavExpansion={toggleNavExpansion}
                  />
                </div>
              )}
            </Nav>
            <Nav>
              {/* USER MENU */}
              {!isAdmin && isAuthenticated && (
                <NavDropdown
                  title={
                    <span className="navbar-main-button">{`Hi, ${firstName}!`}</span>
                  }
                  id="collasible-nav-dropdown"
                  className="navbar-admin-button"
                >
                  <UserNavMenu quantity={quantity} logout={handleLogout} />
                </NavDropdown>
              )}
              {!isAdmin && isAuthenticated && (
                <div className="navbar-admin-menu-small-screen">
                  <UserNavMenu
                    quantity={quantity}
                    logout={handleLogout}
                    toggleNavExpansion={toggleNavExpansion}
                  />
                </div>
              )}
            </Nav>
            <Nav>
              {/* PUBLIC MENU */}
              {!isAuthenticated && (
                <>
                  <LinkContainer
                    to="/login"
                    onClick={() => setNavExpanded(false)}
                  >
                    <Nav.Link className="navbar-collapsed-menu-button navbar-main-button">
                      Login
                    </Nav.Link>
                  </LinkContainer>

                  <LinkContainer
                    to="/register"
                    onClick={() => setNavExpanded(false)}
                  >
                    <Nav.Link className="navbar-collapsed-menu-button navbar-main-button">
                      Register
                    </Nav.Link>
                  </LinkContainer>
                  <Nav.Link className="navbar-admin-menu-small-screen mt-0">
                    <UserCartMenuItem
                      quantity={quantity}
                      toggleNavExpansion={toggleNavExpansion}
                    />
                  </Nav.Link>
                </>
              )}
              {!isAdmin && (
                <Nav.Link
                  className="navbar-admin-button pointer"
                >
                  <UserCartMenuItem quantity={quantity} />
                </Nav.Link>
              )}
            </Nav>
            <SearchBar smallScreen toggleNavExpansion={toggleNavExpansion} />
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* logout alert message */}
      {showLogoutMsg && 
      <ModalMessage
          message="Are you sure you want to logout? Any open chats you may have will be closed." 
          // setErrorMsg={setShowLogoutMsg}
          showLogoutButton={true}
          setShowLogoutMsg={setShowLogoutMsg}
        />
      }
    </>
  );
}